import { Link } from '../common';
export interface Unit {
  unitCode: string;
  unitDesc: string;
  unitId: number;
  _links?: Link[];
}
